window.addEventListener('DOMContentLoaded', () => {

  setTimeout(()=>{customerFormValidationWrapper()}, 500);

  function customerFormValidationWrapper() {
    const formFields = document.getElementsByClassName("login-form-field");
    let formEmailError = document.querySelector(".login-form-email-error");
    let formPasswordError = document.querySelector(".login-form-password-error");
    let formEmailRecoveryError = document.querySelector(".login-form-email-recovery-error");
    const loginFormSubmitButton = document.querySelector(".login-form-button-submit");
    const recoveryFormSubmitButton = document.querySelector(".login-form-button-recovery");
    const emailInput = document.querySelector(".login-form-field-email");

    // on load set submits as disabled

    for (let i = 0; i < formFields.length; i++) {
      formFields[i].addEventListener('input', function (eventClicked) {
        const formValues = formFields[i].value;

        // Email input check
        if (eventClicked.target.classList.contains("login-form-field-email")) {
          if (formValues === "") {
            formEmailError.style.display = "block";
            formEmailError.innerHTML = "Email can not be blank";
            formFields[i].classList.add("form-validation-error");
            loginFormSubmitButton.disabled = true;
          } else {
            formEmailError.style.display = "none";
            formEmailError.innerHTML = "";
            formFields[i].classList.remove("form-validation-error");
            loginFormSubmitButton.disabled = false;
          }
        }

        // Password input check
        if (eventClicked.target.classList.contains("login-form-field-password")) {
          if (formValues.length > 5) {
            formPasswordError.style.display = "none";
            formPasswordError.innerHTML = "";
            formFields[i].classList.remove("form-validation-error");
            loginFormSubmitButton.disabled = false;
          } else if (formValues === "") {
            formPasswordError.style.display = "block";
            formPasswordError.innerHTML = "Password can not be blank";
            formFields[i].classList.add("form-validation-error");

            loginFormSubmitButton.disabled = true;
          } else if (formValues.length < 6 && formValues.length >= 1) {
            formPasswordError.style.display = "block";
            formPasswordError.innerHTML = "Password must be 6 characters long";
            formFields[i].classList.add("form-validation-error");

            loginFormSubmitButton.disabled = true;
          }
        }

        // Email recovery input check
        if (eventClicked.target.classList.contains("login-form-field-email-recovery")) {
          if (formValues === "") {
            formEmailRecoveryError.style.display = "block";
            formEmailRecoveryError.innerHTML = "Email can not be blank";
            formFields[i].classList.add("form-validation-error");

            recoveryFormSubmitButton.disabled = true;
          } else {
            formEmailRecoveryError.style.display = "none";
            formEmailRecoveryError.innerHTML = "";
            formFields[i].classList.remove("form-validation-error");
            recoveryFormSubmitButton.disabled = false;
          }
        }
      });
    }
    preventSubmit();

    function preventSubmit() {
      for (let i = 0; i < formFields.length; i++) {

        // Login form submit check
        loginFormSubmitButton.addEventListener('click', (eventSubmit) => {
          if ((formEmailError.style.display === "block") || (formPasswordError.style.display === "block")) {
            loginFormSubmitButton.disabled = true;
            eventSubmit.preventDefault();
          }
          if (formFields[i].classList.contains("login-form-field-email") && formFields[i].value === "") {
            formEmailError.style.display = "block";
            formEmailError.innerHTML = "Email can not be blank";
            formFields[i].classList.add("form-validation-error");
            loginFormSubmitButton.disabled = true;
            eventSubmit.preventDefault();
          }
          if (formFields[i].classList.contains("login-form-field-password") && formFields[i].value === "") {
            formPasswordError.style.display = "block";
            formPasswordError.innerHTML = "Password can not be blank";
            formFields[i].classList.add("form-validation-error");
            loginFormSubmitButton.disabled = true;
            eventSubmit.preventDefault();
          }
        });

        // Recovery form submit check
        recoveryFormSubmitButton.addEventListener('click', (eventSubmit) => {
          if (formEmailRecoveryError.style.display === "block") {
            formEmailRecoveryError.disabled = true;
            eventSubmit.preventDefault();
          }
          if (formFields[i].classList.contains("login-form-field-email-recovery") && formFields[i].value === "") {
            formEmailRecoveryError.style.display = "block";
            formEmailRecoveryError.innerHTML = "Email can not be blank";
            formFields[i].classList.add("form-validation-error");
            formEmailRecoveryError.disabled = true;
            eventSubmit.preventDefault();
          }
        });
      }

    }
  }


});
